import DOMController from "./abstract/DOMController";
import { triggerCustomEvent } from "./EventTrigger";

export default class Switcher extends DOMController
{
    protected root: Element;
    protected classes = {
        button: 'switcher__button',
        active: 'switcher__button_active',
    };

    public constructor(root: Element)
    {
        super();

        this.root = root;

        this.appendEventListeners();
    }

    protected appendEventListeners()
    {
        this.root.querySelectorAll('.' + this.classes.button).forEach(button => {this.buttonClickHandler(button)});
    }

    private buttonClickHandler(button: Element)
    {
        button.addEventListener('click', () => {
            if (button.classList.contains(this.classes.active)) {
                return;
            }

            let buttons = this.root.querySelectorAll('.' + this.classes.button);
            buttons.forEach(btn => btn.classList.remove(this.classes.active));
            
            button.classList.add(this.classes.active);

            this.triggerClickEvent(button.getAttribute('data-value'));
        });
    }

    private triggerClickEvent(value: string)
    {
        triggerCustomEvent(this.root, 'switcher-change', {
            detail: value,
        });
    }
}
